import React, { ReactNode, useState } from "react";

export type TabDataProp = {
  label: string;
  element: ReactNode;
};

export type TabsProps = {
  activeTabIndex?: number;
  data: TabDataProp[];
};

export const Tabs = ({ data, activeTabIndex = 0 }: TabsProps) => {
  const [activeTab, setActiveTab] = useState<number>(activeTabIndex);

  const baseClassname = "tabs";

  function buildTabList() {
    return data.map((current, index) => (
      <button
        className={`${baseClassname}__list-button ${activeTab === index ? "active" : ""}`}
        key={index}
        onClick={() => setActiveTab(index)}
      >
        {current.label.charAt(0).toUpperCase() + current.label.slice(1)}
      </button>
    ));
  }

  function buildTabContent() {
    return data.map((current, index) => (
      <div
        key={index}
        className={`${baseClassname}__content`}
        hidden={activeTab !== index}
      >
        {current.element}
      </div>
    ));
  }

  return (
    <div className={`${baseClassname}`}>
      <div className={`${baseClassname}__list`}>{buildTabList()}</div>
      {buildTabContent()}
    </div>
  );
};
